import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { Flight, FlightLand, FlightTakeoff, Redo, ArrowUpwardOutlined } from '@material-ui/icons';
import { styles, colorsSet } from './style';
import { Fade } from "react-awesome-reveal";
import { IFlight } from '../utils/models';

const CustomCard: React.FC<{flight: IFlight}> = ({flight}) => {
	const [styleSelector, setStyleSelector] = useState(0)

	useEffect(() => {
		setStyleSelector(parseInt((Math.floor(Math.random() * 140) / 20).toFixed(0)))
	}, [flight])

	const openOnMap = () => {
		const lat = (flight.departure.lat + flight.arrival.lat) / 2;
		const lon = (flight.departure.lon + flight.arrival.lon) / 2;
		const newPageUrl = `https://skyvector.com/?ll=${lat},${lon}&zoom=6&fpl=%20${flight.departure.icao}%20${flight
			.arrival.icao}`;
		window.open(newPageUrl, '_blank');
	};

	const selectSecondaryColor = () => {
		return colorsSet[styleSelector] ? colorsSet[styleSelector].secondaryColor : '#fff'
	}

	return (
		<Fade>
			<div style={styles.cardContainer} onClick={() => openOnMap()}>
				<div style={{
					padding: '10px 20px',
					flexDirection: 'column',
					borderRadius: '16px 16px 8px 8px',
					border: '1px solid black',
					borderBottom: '1px dashed black',
					boxShadow: '10px 10px 10px grey',
					...colorsSet[styleSelector]
				}}
				>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<FlightTakeoff style={{ color: selectSecondaryColor() }} />
						<Typography
							variant="body1"
							align="left"
							style={{
								whiteSpace: 'nowrap',
								textOverflow: 'ellipsis',
								overflow: 'hidden',
								marginLeft: 4
							}}
						>
							{flight.departure.name}
						</Typography>
					</div>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<FlightLand style={{ color: selectSecondaryColor() }} />
						<Typography
							variant="body1"
							align="left"
							style={{
								whiteSpace: 'nowrap',
								textOverflow: 'ellipsis',
								overflow: 'hidden',
								marginLeft: 4
							}}
						>
							{flight.arrival.name}
						</Typography>
					</div>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<Redo style={{ color: selectSecondaryColor() }} />
						<Typography variant="body1" align="left" style={{ marginLeft: 4 }}>
							{`${flight.distance.toFixed(0)} NM`}
						</Typography>
					</div>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<ArrowUpwardOutlined style={{ color: selectSecondaryColor(), transform: `rotate(${flight.bearing.toFixed(0)}deg)` }} />
						<Typography variant="body1" align="left" style={{ marginLeft: 4 }}>
							{`${flight.bearing.toFixed(0)}°`}
						</Typography>
					</div>
				</div>
				<div style={{ ...styles.bottomCardContainer, ...colorsSet[styleSelector] }}>
					<div style={{ overflow: 'hidden' }}>
						<Typography
							variant="body1"
							align="left"
							style={{ whiteSpace: 'pre', textOverflow: 'ellipsis', overflow: 'hidden', color: selectSecondaryColor() }}
						>
							{` ${flight.departure.city ? flight.departure.city : flight.departure.name}`}
						</Typography>
						<Typography
							variant="body2"
							align="left"
							style={{ whiteSpace: 'pre', fontSize: 12, textOverflow: 'ellipsis', overflow: 'hidden', color: selectSecondaryColor() }}
						>
							{` ${flight.departure.country}`}
						</Typography>
						<Typography variant="h3" align="left">
							{flight.departure.icao}
						</Typography>
					</div>
					<div style={{ textAlign: 'center', width: 260, color: selectSecondaryColor() }}>
						<Flight fontSize="large" style={{ transform: 'rotate(90deg)' }} />
					</div>
					<div style={{ overflow: 'hidden' }}>
						<Typography
							variant="body1"
							align="right"
							style={{ whiteSpace: 'pre', textOverflow: 'ellipsis', overflow: 'hidden', color: selectSecondaryColor() }}
						>
							{` ${flight.arrival.city ? flight.arrival.city : flight.arrival.name}`}
						</Typography>
						<Typography
							variant="body2"
							align="right"
							style={{ whiteSpace: 'pre', fontSize: 12, textOverflow: 'ellipsis', overflow: 'hidden', color: selectSecondaryColor() }}
						>
							{` ${flight.arrival.country}`}
						</Typography>
						<Typography variant="h3" align="right">
							{flight.arrival.icao}
						</Typography>
					</div>
				</div>
			</div>
		</Fade>
	);
};

export default CustomCard;
